import React, { useRef } from 'react';
import { Appearance, ScrollView } from 'react-native';
import RBSheet from 'react-native-raw-bottom-sheet';
import { colorSwatches } from '../styles';

interface ThemedSwipeablePanelProps {
  isActive: boolean;
  onClose: () => void;
  showCloseButton?: boolean;
  children: React.ReactNode;
  style?: any;
  fullWidth?: boolean;
  onlyLarge?: boolean;
}

export default function ThemedSwipeablePanel({
  isActive,
  onClose,
  showCloseButton = true,
  children,
  style,
  fullWidth = false,
  onlyLarge = false,
}: ThemedSwipeablePanelProps) {
  const bottomSheetRef = useRef<RBSheet>(null);
  const colorScheme = Appearance.getColorScheme();
  const isDarkMode = colorScheme === 'dark';

  React.useEffect(() => {
    if (isActive) {
      bottomSheetRef.current?.open();
    } else {
      bottomSheetRef.current?.close();
    }
  }, [isActive]);

  return (
    <RBSheet
      ref={bottomSheetRef}
      closeOnDragDown={true}
      closeOnPressMask={true}
      onClose={onClose}
      height={600}
      customStyles={{
        container: {
          backgroundColor: isDarkMode ? '#1a1a1a' : colorSwatches.white.color,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
        wrapper: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        draggableIcon: {
          backgroundColor: isDarkMode ? '#666' : '#ccc',
          width: 40,
          height: 5,
        },
      }}>
      <ScrollView
        style={[
          {
            paddingHorizontal: 16,
            paddingVertical: 8,
            flex: 1,
          },
          style,
        ]}
        scrollEnabled={true}
        showsVerticalScrollIndicator={true}>
        {children}
      </ScrollView>
    </RBSheet>
  );
}
